import { axiosCms } from 'Axios.js';
import { authToken } from '../utility';
import * as actionTypes from './actionTypes';

const fetchListStart = () => ({ type: actionTypes.FETCH_LIST_START });
const fetchListEnd = data => ({ type: actionTypes.FETCH_LIST_END, data });
const DLListStart = () => ({ type: actionTypes.DL_LIST_START });
const DLListEnd = () => ({ type: actionTypes.DL_LIST_END });

export const fetchList = id => dispatch => {
  dispatch(fetchListStart());
  axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
  return axiosCms
    .get('/lists/' + id)
    .delay(500)
    .then(response => {
      const { data } = response;
      return dispatch(fetchListEnd(data));
    })
    .catch(err => {
      console.error('#fetchList: ', err);
      return Promise.reject(err);
    });
};

export const downloadList = id => dispatch => {
  dispatch(DLListStart());
  const additionalHeaders = { responseType: 'arraybuffer' };
  axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
  return axiosCms
    .get('/lists/' + id + '/pdf', additionalHeaders)
    .then(resp => {
      dispatch(DLListEnd());
      return resp.data;
    })
    .catch(err => {
      console.error('#downloadList', err);
      return Promise.reject(err);
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/lists.js